// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1fbWp","selected":"Chip_selected__2dqJS"};